import {Component, Input, OnInit} from '@angular/core';
import {ApprovalService} from '../../../service/approval.service';
import {ChecklistModel} from '../../../shared/dto/checklist.model';
import {Router} from '@angular/router';
import {ApprovalModel} from '../../../shared/dto/approval.model';
import {FormControl, FormGroup} from '@angular/forms';
import Swal, {default as swal} from 'sweetalert2';
import {BlacklistService} from '../../../shared/service/blacklist.service';

@Component({
  selector: 'app-remarks',
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.scss']
})
export class RemarksComponent implements OnInit {

  remarkForm: FormGroup;
  @Input() fromParent;
  approvalModel: ApprovalModel = new ApprovalModel();
  isError: boolean = false;
  isSucess: boolean = false;
  public checklist: ChecklistModel[];
  public isValidChecklist = true;
  public selectedIdArr: number[]=[];
  public checklistId: number[]=[];
  public appType:string;

  constructor(private approvalService: ApprovalService,
              private router: Router,
              private blacklistService:BlacklistService) { }

  ngOnInit() {
    this.approvalModel = this.fromParent.model;
    this.appType = this.fromParent.appType;
    this.remarkForm = new FormGroup({
      remark: new FormControl(null),
    });
  }

  submitRequest() {
    this.approvalModel.remark = this.remarkForm.value.remark;

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to approve the request?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.blacklistService.approveRequeat(this.approvalModel).subscribe(
          (success: string) => {
            // alert("Test1");

            swal.fire('Success', 'Applicant Details Updated', 'success');
            if(this.router.url.includes('/dashboard/blacklist-data/')){
              this.router.navigate(['/dashboard/blacklist/'+this.appType] );

            }else if(this.router.url.includes('/dashboard/reversed-blacklist-data/')){
              this.router.navigate(['/dashboard/reversed-blacklist'+this.appType] );

            }else if(this.router.url.includes('/dashboard/blacklist-return-data/')) {
              this.router.navigate(['/dashboard/blacklist-return-data'+this.appType]);
            }
            else if(this.router.url.includes('/dashboard/blacklist-verification/')) {
              this.router.navigate(['/dashboard/blacklist-verification'+this.appType]);
            }

            if(this.approvalModel.stage != null){
              this.router.navigate(['/dashboard/suspend-blacklist-return-data']);
            }
            this.approvalService.close();
          },
          (error) => {
            swal.fire('Error', 'Error When Updating the Request', 'error');
          },
        );
      } else {
      }
    });
  }
}
